<!-- Start event details -->
@if (display_type === 1) {
  <div class="central-header central-header--claims d-none d-md-flex">
    <h3 class="font-normal">{{claim_details?.claim_name}}</h3>
    <!-- <div class="dropdown d-none d-md-inline-block">
    <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-none d-md-block"
      data-toggle="dropdown" aria-expanded="false">
      <svg class="icon">
        <use xlink:href="#more"></use>
      </svg>
    </a>
    <a href="#modal-traymenu-actions"
      class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
      <svg class="icon">
        <use xlink:href="#more"></use>
      </svg>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
      <a class="dropdown-item" data-sortby="best_value">
        <svg class="icon">
          <use xlink:href="#add-items"></use>
        </svg>
        <span>Add Item or Benefit</span>
      </a>
      <a class="dropdown-item" data-sortby="best_value">
        <svg class="icon text-color-error">
          <use xlink:href="#trash-bin"></use>
        </svg>
        <span>Cancel Claim</span>
      </a>
    </div>
  </div> -->
</div>
<!-- <div class="policy-card__summary mb-15 d-none d-md-block">
<div class="policy-card__summary-inner seemore__expander" id="personal-item-5-more">
  <div class="policy-card__summary-items">
    <ul class="summary-list list-unstyled summary-list--tracker">
      <li>
        <small>Claim Ref No.</small>
        <span class="font-bold">{{claim_details?.claim_id}}</span>
      </li>
      <li>
        <small>Policy No.</small>
        <span class="font-semibold">{{claim_details?.policy_id}}/{{claim_details?.version_id}}</span>
      </li>
      <li>
        <small>Estimated Value</small>
        <span class="font-semibold">-</span>
      </li>
      <li>
        <small>Amount Paid</small>
        <span class="font-semibold">-</span>
      </li>
      <li>
        <small>Status</small>
        <span class="tag-pill tag-pill--active"> <svg class="icon"><use xlink:href="#complete"></use></svg>
      {{claim_details?.claim_status}} </span>
    </li>
  </ul>
</div>
</div>
</div> -->
@if (claim_details?.claim_status == 'Registered') {
  <div class="card card--post-header card--notification mt-30">
    <div class="card-body">
      <div class="card__avatar">
        <picture>
          <source media="(min-width: 768px)" srcset="assets/0/avatar/face-happy.png">
          <img src="assets/0/avatar/happy.png" alt="" class="img-fluid">
        </picture>
      </div>
      <div class="card__content">
        <div class="card__copy">
          <p class="text-center text-md-left">Your claim has been registered. We will get back to you with next the steps
          - expect to hear from us within one to two business days. </p>
        </div>
      </div>
    </div>
  </div>
}
<div class="central-header central-header--claims central-header--claims-sm d-md-none">
  <h3 class="font-normal">{{claim_details?.claim_name}}</h3>
  <!-- <div class="dropdown d-md-none">
  <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-none d-md-block"
    data-toggle="dropdown" aria-expanded="false">
    <svg class="icon">
      <use xlink:href="#more"></use>
    </svg>
  </a>
  <a href="#modal-traymenu-actions"
    class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
    <svg class="icon">
      <use xlink:href="#more"></use>
    </svg>
  </a>
  <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
    <a class="dropdown-item" data-sortby="best_value">
      <svg class="icon">
        <use xlink:href="#add-items"></use>
      </svg>
      <span>Add Item or Benefit</span>
    </a>
    <a class="dropdown-item" data-sortby="best_value">
      <svg class="icon text-color-error">
        <use xlink:href="#trash-bin"></use>
      </svg>
      <span>Cancel Claim</span>
    </a>
  </div>
</div> -->
</div>
<!-- <div class="policy-card__summary mb-15 d-md-none">
<div class="policy-card__summary-inner seemore__expander" id="personal-item-5-more">
  <div class="policy-card__summary-items pt-20">
    <ul class="summary-list list-unstyled summary-list--tracker">
      <li>
        <small>Claim Ref No.</small>
        <span class="font-bold">{{claim_details?.claim_id}}</span>
      </li>
      <li>
        <small>Policy No.</small>
        <span class="font-semibold">{{claim_details?.policy_id}}/{{claim_details?.version_id}}</span>
      </li>
      <li>
        <small>Estimated Value</small>
        <span class="font-semibold">R 2 350 000</span>
      </li>
      <li>
        <small>Amount Paid</small>
        <span class="font-semibold">R 1 200 000</span>
      </li>
      <li>
        <small>Status</small>
        <span class="tag-pill tag-pill--active"> <svg class="icon"><use xlink:href="#complete"></use></svg>
      {{claim_details?.claim_status}}</span>
    </li>
  </ul>
</div>
</div>
</div> -->
<div class="card card--edit card--edit-summary">
  <div class="card-body">
    <div class="card__content">
      <h4 class="pb-30">Event Details</h4>
      @for (question of questions; track question; let last = $last) {
        <app-question-controller
          [question]="question"
          [isEditModal]="true"
          [showLabel]="true"
          [controlCssClass]="(!last ? 'mb-40' : '')"
          (questionAnswer)="questionResponse($event)">
        </app-question-controller>
      }
    </div>
  </div>
</div>
}
<!--End Event Details-->


<!-- Item Details -->
@if (display_type === 2) {
  <div class="central-header central-header--claims">
    <h3 class="font-normal">{{cart_item?.description ? cart_item?.description?.split('|')[0] : ''}}</h3>
    <div class="dropdown d-none d-md-inline-block">
      <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-none d-md-block"
        data-toggle="dropdown" aria-expanded="false">
        <svg class="icon">
          <use xlink:href="#more"></use>
        </svg>
      </a>
      <a href="#modal-traymenu-actions"
        class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
        <svg class="icon">
          <use xlink:href="#more"></use>
        </svg>
      </a>
      <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
        <!--<a class="dropdown-item" data-sortby="best_value">
        <svg class="icon">
          <use xlink:href="#pause"></use>
        </svg>
        <span>Pause Claim</span>
      </a>-->
      <a class="dropdown-item" data-sortby="best_value" (click)="removeItem.emit({item: cart_item})">
        <svg class="icon">
          <use xlink:href="#trash-bin"></use>
        </svg>
        <span>Remove</span>
      </a>
    </div>
  </div>
</div>
<div class="card card--edit">
  <div class="card-title">
    <h4>Claim Details</h4>
  </div>
  <div class="card-body">
    <!--<a (click)="getDetails()" class="jumbo-button">
    <div class="jumbo-button__left">
      <svg class="icon">
        <use xlink:href="#camera"></use>
      </svg>
      <h5 class="font-16 font-semibold">Damage Report</h5>
    </div>
    <svg class="icon">
      <use xlink:href="#chevron-right-small"></use>
    </svg>
  </a>-->
</div>
</div>
<div class="mt-20" id="group-items-accordion">
  @for (group of questionGroups; track group) {
    @if (group?.class_id === cart_item?.class_id) {
      <div class="card card--freeform">
        <a [href]="'#' + group?.group_type + '-' + group?.class_id" class="card-title collapsed" data-toggle="collapse" aria-expanded="false">
          <div class="card-title__text">
            <div class="card-title__text-wrap">
              <h5 class="font-16 font-semibold">{{group?.group_name}}</h5>
            </div>
          </div>
          <div class="card-title__caret">
            <svg class="icon">
              <use xlink:href="#dropdown"></use>
            </svg>
          </div>
        </a>
        <div class="card-body collapse" [id]="group?.group_type + '-' + group?.class_id" [attr.data-parent]="'#group-items-accordion'">
          <div class="card__content">
            @for (question of group?.questions; track question) {
              <app-question-controller
                [showLabel]="true"
                [damageModalNarrow]="true"
                [showSkip]="false"
                [showParent]="false"
                [childItemQuestions]="getChildQuestions(question?.cent_aq_question_id, question?.item_id)"
                [question]="question"
                (questionAnswer)="questionResponse($event)">
              </app-question-controller>
            }
          </div>
        </div>
      </div>
    }
  }
</div>
}

@if (display_type === 3) {
  <div class="central-header central-header--claims">
    <h3 class="font-normal">{{cart_item?.description ? cart_item?.description?.split('|')[0] : ''}}</h3>
  </div>
  <div class="card card--edit">
    <div class="card-body">
      <div class="card__content">
        @for (question of questions; track question) {
          <app-question-controller
            [showLabel]="true"
            [damageModalNarrow]="true"
            [showSkip]="false"
            [showParent]="false"
            [childItemQuestions]="getChildQuestions(question?.cent_aq_question_id, question?.item_id)"
            [question]="question"
            [controlCssClass]="question?.highlight+' form-group'"
            (questionAnswer)="questionResponse($event)">
          </app-question-controller>
        }
      </div>
    </div>
  </div>
  <!-- <div class="mt-20" id="group-items-accordion">
  <ng-container *ngFor="let group of questionGroups">
    <div class="card card--freeform" *ngIf="group?.class_id === cart_item?.class_id">
      <a [href]="'#' + group?.group_type + '-' + group?.class_id" class="card-title collapsed" data-toggle="collapse" aria-expanded="false">
        <div class="card-title__text">
          <div class="card-title__text-wrap">
            <h5 class="font-16 font-semibold">{{group?.group_name}}</h5>
          </div>
        </div>
        <div class="card-title__caret">
          <svg class="icon">
            <use xlink:href="#dropdown"></use>
          </svg>
        </div>
      </a>
      <div class="card-body collapse" [id]="group?.group_type + '-' + group?.class_id" [attr.data-parent]="'#group-items-accordion'">
        <div class="card__content">
          <app-question-controller
            *ngFor="let question of group?.questions"
            [showLabel]="true"
            [damageModalNarrow]="true"
            [showSkip]="false"
            [showParent]="false"
            [childItemQuestions]="getChildQuestions(question?.cent_aq_question_id, question?.item_id)"
            [question]="question"
            (questionAnswer)="questionResponse($event)">
          </app-question-controller>
        </div>
      </div>
    </div>
  </ng-container>
</div> -->
}
